import i18n from '@/i18n'
import $axios from './apiConnection'
import parseCatch from '@/helpers/handleErrors'
import notification from '@/mixins/simpleNotification'

export const LayoutApi = {
    async get(data) {
        try {
            const { Data } = await $axios.post('/Layout/List/', data)
            return Data
        } catch (e) {
            parseCatch(e, true, 'Get Layouts')
        }
    },
    async update(data) {
        try {
            const result = await $axios.post('/Layout/Upsert/', data)
            if (data.LayoutID) {
                notification.call({
                    type: 'success',
                    message: i18n.t('layout.layoutUpdatedWithSuccess')
                })
            } else {
                notification.call({
                    type: 'success',
                    message: i18n.t('layout.layoutAddedWithSuccess')
                })
            }
            return result
        } catch (e) {
            parseCatch(e, true, 'Update Account Layout')
        }
    },
    async updateStatus(data) {
        try {
            return await $axios.post('/Layout/UpdateStatus/', data)
        } catch (e) {
            parseCatch(e, true, 'Update Layout Status')
        }
    },
}
